import { Loading } from '../loading';
import { useGlobalLoading } from './hook';
import './style.scss';

export const GlobalLoading = () => {
  const { isShow } = useGlobalLoading();

  if (!isShow) return;

  return (
    <div className={`centerLoadingWrapper`}>
      <Loading />
    </div>
  );
};
